import React, {
  useState,
  useEffect,
  useMemo,
  useCallback,
  useContext,
  useRef,
} from "react";
import "./CodeBook.css";
import booksIcon from "../../assets/books.png";
import bookInactiveIcon from "../../assets/booksinactive.png";
import achiIcon from "../../assets/achiinedx.png";
import tabularicdIcon from "../../assets/icdtabular.png";
import australianIcon from "../../assets/austrilaincode.png";
import bookIcon from "../../assets/book.png";
import icd10amIcon from "../../assets/icd10am.png";
import starsIcon from "../../assets/starts.png";
import { CodeContext } from "../pages/Coder/Coder";
import { useDebounce } from "use-debounce";
import { toast } from "react-toastify";
import { useSelector, useDispatch } from "react-redux"; // Import useSelector
import { Spinner } from "react-bootstrap";
import LdsRoller from "../../utils/LdsRoller";
import AustralianCodebook from "./AustralianCodebook";
import earthIcon from "../../assets/earth-asia.png";
import earthinactiveIcon from "../../assets/earth-asia-inactive.png";
import AcsReferencesCodebook from "./ACSReferencesCodebook";
import {
  clearHyperlinkNavigationHistory,
  popNavigationEntry,
  pushNavigationEntry,
  setOnChangeCodeBook,
  setSelectedCodebookVersion,
  updateAcsCode,
  updateNcaCode,
} from "./redux/CodeBookSlicer";
// import { clearAcsCode } from "./redux/CodeBookSlicer";
// import {  } from "./redux/CodeBookSlicer";
import {
  fetchCodebookData,
  fetchCodebookData13,
  setActiveIcon,
  setActiveTab,
  setRawSearchQuery,
  setSearchByCodeId,
  setNondraggablecode,
} from "./redux/CodeBookSlicer";
import ACSCodeBook13th from "./ACSCodeBook13th";
import NCADocumentViewer from "./NCADocumentViewer";
import SearchableIframe from "./documentSearch/SearchableIframe";

import AccordionItem from "./CodeBookAccordionItem";
import { CodeBookHeader, CodeBookSearchField, CodeBookTabs } from "./CodeBookControls";
const CodeBookDev = React.memo(({ isLockedCoder }) => {
  // console.log( dischargeDate," dischargeDate====================")
  const dispatch = useDispatch();
  const {
    icd10amTabularData,
    icd10amIndexData,
    achiIndexData,
    achiTabularData,
    icd10amTabularData13,
    icd10amIndexData13,
    achiIndexData13,
    achiTabularData13,
    codeBookLoading,
    codeBookError,
    activeTab,
    activeIcon,
    rawSearchQuery,
    searchByCodeId,
    onChangeCodeBook,
  } = useSelector((state) => state.codeBook);
    // console.log(icd10amIndexData13, "jyo1");
  // // console.log(achiTabularData13,"jyo5");
  // console.log(icd10amTabularData13, "jyo2");
  //   console.log( achiIndexData13, "jyo1");


  const [searchQuery, setSearchQuery] = useState("");
  const [droppedCodes, setDroppedCodes] = useState([]);
  const [selectedReference, setSelectedReference] = useState(null);

  const { selectedCodeBookCode, selectedTabKeyCoding } =
    useContext(CodeContext);
  // const [selectedCodebookVersion, setSelectedCodebookVersion] = useState("");
  const [isUserSelectedCodebookVersion, setIsUserSelectedCodebookVersion] =
    useState(false);
  const selectedEpisode = useSelector(
    (state) => state.episodeList.selectedEpisode,
  );
  const [showReferencesDropdown, setShowReferencesDropdown] = useState(false);
  const dischargeDate = selectedEpisode?.separation_date || null;
  const isFetched12 = useSelector((state) => state.codeBook.isFetched12);
  const isFetched13 = useSelector((state) => state.codeBook.isFetched13);
  const { selectedCodebookVersion } = useSelector((state) => state.codeBook);
  const { selectedCodeDetails } = useSelector((state) => state.codeSearch);
  const nondraggablecode = useSelector(
    (state) => state.codeBook.nondraggablecode,
  );
  const navigationHistory = useSelector((s) => s.codeBook.navigationHistory);
  const scrollRestoreTarget = useSelector(
    (s) => s.codeBook.scrollRestoreTarget,
  );
  const restoringRef = useRef(false);
  const pendingScrollRef = useRef(null);
  const pendingAnchorRef = useRef(null);
  const scrolledForTargetRef = useRef(null);
  const skipCenterScrollRef = useRef(false);
  const [displayedItems, setDisplayedItems] = useState([]); // Items to render
  const [loadMore, setLoadMore] = useState(50); // Number of items to load
  const searchResultsRef = React.useRef(null);
  const skipTabClearRef = useRef(false);
  const [debouncedQuery, debouncedQueryControl] = useDebounce(
    rawSearchQuery,
    300,
  );
  // console.log(data,"selectedCodeDetails");
  useEffect(() => {
    if (!isUserSelectedCodebookVersion) {
      if (!dischargeDate) {
        // Discharge date missing → default to 13th
        dispatch(setSelectedCodebookVersion("13th"));
      } else {
        const discharge = new Date(dischargeDate);
        const cutoff = new Date("01-07-2025");

        // discharge <= June 30, 2025 → 12th; else → 13th
        if (discharge < cutoff) {
          dispatch(setSelectedCodebookVersion("12th"));
        } else {
          dispatch(setSelectedCodebookVersion("13th"));
        }
      }
    }
  }, [dischargeDate, isUserSelectedCodebookVersion]);

  // Clear on tab change
useEffect(() => {
  if (skipTabClearRef.current) {
    skipTabClearRef.current = false;
    return;
  }
  dispatch(setRawSearchQuery(""));
  dispatch(setSearchByCodeId(null));
  dispatch(setNondraggablecode(false));
  dispatch(setOnChangeCodeBook(false));
}, [activeTab, dispatch]);

  const handleChange = (e) => {
    dispatch(setSelectedCodebookVersion(e.target.value));
    setIsUserSelectedCodebookVersion(true);
  };

  // This depends on your selected edition
  // useEffect(() => {
  //   if (selectedCodebookVersion === "12th" && !isFetched12) {
  //     dispatch(fetchCodebookData());
  //   } else if (selectedCodebookVersion === "13th" && !isFetched13) {
  //     dispatch(fetchCodebookData13());
  //   }
  // }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);
  // useEffect(() => {
  //   const shouldFetch12 =
  //     selectedCodebookVersion === "12th" &&
  //     !isFetched12;

  //   const shouldFetch13 =
  //     selectedCodebookVersion === "13th" &&
  //     !isFetched13;

  //   if (shouldFetch12) {
  //     dispatch(fetchCodebookData());
  //   } else if (shouldFetch13) {
  //     dispatch(fetchCodebookData13());
  //   }
  // }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);

  useEffect(() => {
    const fetchData = async () => {
      if (selectedCodebookVersion === "12th" && !isFetched12) {
        dispatch(fetchCodebookData());
      } else if (selectedCodebookVersion === "13th" && !isFetched13) {
        dispatch(fetchCodebookData13());
      }
    };

    fetchData();
  }, [selectedCodebookVersion, isFetched12, isFetched13, dispatch]);

  const tabsConfig = useMemo(() => {
    const is13 = selectedCodebookVersion === "13th";
    return [
      {
        name: "ICD 10 AM Index",
        data: is13 ? icd10amIndexData13 : icd10amIndexData,
      },
      {
        name: "ICD 10 AM Tabular",
        data: is13 ? icd10amTabularData13 : icd10amTabularData,
      },
      {
        name: "ACHI Tabular",
        data: is13 ? achiTabularData13 : achiTabularData,
      },
      { name: "ACHI Index", data: is13 ? achiIndexData13 : achiIndexData },
      { name: "Australian Coding Standard", data: [] },
      { name: "Additional References", data: [] },
    ];
  }, [
    selectedCodebookVersion,
    icd10amIndexData,
    icd10amTabularData,
    achiTabularData,
    achiIndexData,
    icd10amIndexData13,
    icd10amTabularData13,
    achiTabularData13,
    achiIndexData13,
  ]);

  const getTabError = () => {
    if (!codeBookError) return null;
    switch (activeTab) {
      case "ICD 10 AM Tabular":
        return codeBookError.icd10amTabular
          ? `Failed to load ICD 10 AM Tabular data: ${codeBookError.icd10amTabular}`
          : null;
      case "ICD 10 AM Index":
        return codeBookError.icd10amIndex
          ? `Failed to load ICD 10 AM Index data: ${codeBookError.icd10amIndex}`
          : null;
      case "ACHI Tabular":
        return codeBookError.achiTabular
          ? `Failed to load ACHI Tabular data: ${codeBookError.achiTabular}`
          : null;
      case "ACHI Index":
        return codeBookError.achiIndex
          ? `Failed to load ACHI Index data: ${codeBookError.achiIndex}`
          : null;
      default:
        return null;
    }
  };

  const tabError = getTabError();

  useEffect(() => {
    const savedActiveTab = sessionStorage.getItem("activeTab");
    const savedActiveIcon = sessionStorage.getItem("activeIcon");

    if (savedActiveTab) {
      dispatch(setActiveTab(savedActiveTab)); // Set active tab if saved in sessionStorage
    }

    if (savedActiveIcon) {
      dispatch(setActiveIcon(savedActiveIcon)); // Set active icon if saved in sessionStorage
    }
  }, []);

  useEffect(() => {
    sessionStorage.setItem("activeTab", activeTab); // Save active tab to sessionStorage
    sessionStorage.setItem("activeIcon", activeIcon); // Save active icon to sessionStorage
  }, [activeTab, activeIcon]);

  useEffect(() => {
    // --- Priority 1: CodeAssist search state ---
    if (selectedCodeDetails) {
      dispatch(setSelectedCodebookVersion("13th")); // force 13th

      const { category, code_id, value, isFromTabular } = selectedCodeDetails;
      setTimeout(()=>{
      dispatch(setSearchByCodeId(code_id));
      dispatch(setRawSearchQuery(value));
      },0)

      if (category === "Additional Diagnoses") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 AM Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ICD 10 AM Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
      if (category === "Principal Diagnosis") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ICD 10 AM Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ICD 10 AM Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
      if (category === "Procedure Codes") {
        if (!isFromTabular) {
          // Case 1: Additional Diagnoses from Index
          dispatch(setActiveIcon("ICD"));
          dispatch(setActiveTab("ACHI Index"));
          dispatch(setRawSearchQuery(value));
          return;
        } else {
          // Case 2: Additional Diagnoses from Tabular
          dispatch(setActiveIcon("Tabular"));
          dispatch(setActiveTab("ACHI Tabular"));
          dispatch(setRawSearchQuery(value));
          return;
        }
      }
    }
    // --- Priority 2: Normal flow ---
    if (selectedCodeBookCode && selectedTabKeyCoding) {
      // console.log(selectedCodeBookCode,"selectedCodeBookCode")
      dispatch(setSearchByCodeId(null));
      // Check both are available
      dispatch(setRawSearchQuery(selectedCodeBookCode));
      if (selectedTabKeyCoding === "ACHI") {
        dispatch(setActiveIcon("Tabular")); // Or your preferred ACHI icon
        dispatch(setActiveTab("ACHI Tabular")); // Correct tab for ACHI
      } else {
        // Either ICD or default (ICD)
        dispatch(setActiveIcon("Tabular"));
        dispatch(setActiveTab("ICD 10 AM Tabular")); // Correct tab for ICD (and default)
      }
    } else {
      dispatch(setSearchByCodeId(null));
      dispatch(setRawSearchQuery(""));
      dispatch(setActiveIcon("ICD"));
      dispatch(setActiveTab("ICD 10 AM Index"));
    }
  }, [selectedCodeDetails, selectedCodeBookCode, selectedTabKeyCoding]);

  useEffect(() => {
    if (debouncedQuery?.length >= 2) {
      setSearchQuery(debouncedQuery);
    } else {
      setSearchQuery("");
    }
  }, [debouncedQuery]);

  // const filterData = (items, query) => {
  //   // if (!query) return items; // Return original items if query is empty
  //   if (!query || query.length < 3) return items; // Return empty array

  //   const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : ""; // Handle anything

  //   const results = [];
  //   const filterRecursive = (items) => {
  //     // Inner recursive function
  //     return items
  //       .map((item) => {
  //         const filteredChildren = item.children
  //           ? filterRecursive(item.children)
  //           : [];
  //         const matchesParent =
  //           (item.name && item.name.toLowerCase().includes(lowerCaseQuery)) ||
  //           (item.description &&
  //             item.description.toLowerCase().includes(lowerCaseQuery));

  //         // const matches = matchesParent || filteredChildren.length > 0;

  //         const childrenToInclude = matchesParent
  //           ? item.children || []
  //           : filteredChildren;

  //         return {
  //           ...item,
  //           // children: filteredChildren,
  //           // matches,
  //           children: childrenToInclude, // Preserve all children if parent matches
  //           matches: matchesParent || childrenToInclude.length > 0,
  //         };
  //       })
  //       .filter((item) => item.matches || item.children?.length > 0);
  //   };

  //   return filterRecursive(items);
  // };

  const filterData = (items, query, codeId = null) => {
     // If we have a specific code ID to search for (parent navigation)
  if (codeId) {
    const findParentAndChildren = (items, targetId) => {
      for (const item of items) {
        // Check if this item matches the target ID
        if (item.id === targetId) {
          // Return the entire item with all its children
          return [{
            ...item,
            matches: true,
            // Keep all children intact
            children: item.children || []
          }];
        }

        // Check children recursively
        if (item.children) {
          const foundInChildren = findParentAndChildren(item.children, targetId);
          if (foundInChildren.length > 0) {
            // Return the parent with the matching child
            return [{
              ...item,
              children: foundInChildren,
              matches: true,
            }];
          }
        }
      }
      return [];
    };

    return findParentAndChildren(items, codeId);
  }

  // Original text-based search (fallback)
  if (!query || query.length < 2) return items;

    const lowerCaseQuery = typeof query === "string" ? query.toLowerCase() : "";

    // ---------------- NORMALIZATION ----------------
    const normalize = (str = "") => {
      return str
        .toLowerCase()
        .replace(/\b(see|see also).*$/i, "") // remove "see..." references
        .normalize("NFD")
        .replace(/[\u0300-\u036f]/g, "") // remove accents
        .replace(/['’]/g, "") // remove apostrophes
        .replace(/[()]/g, " ") // keep words inside ()
        .replace(/-/g, " ") // split hyphens
        .replace(/[^a-z0-9\s]/g, " ")
        .replace(/\s+/g, " ")
        .trim();
    };

    const tokenize = (str) => normalize(str).split(" ").filter(Boolean);

    // prepare query once
    const queryNorm = normalize(lowerCaseQuery);
    const queryTokens = tokenize(lowerCaseQuery);

    // ---------------- MATCH FUNCTION ----------------
    const matchText = (text = "") => {
      if (!text) return null;

      const textNorm = normalize(text);
      const queryNormTrimmed = queryNorm.trim();

      // Exact full match
      if (textNorm === queryNormTrimmed) return "exact";

      // always checks for starting terms
      if (textNorm.startsWith(queryNormTrimmed)) return "partial";
      const segments = textNorm.split(",").map((s) => s.trim());
      const firstTokensOfSegments = segments
        .map((s) => s.split(" ")[0])
        .filter(Boolean);

      const matchesSegmentStart = firstTokensOfSegments.some((token) =>
        token.startsWith(queryNormTrimmed),
      );

      if (matchesSegmentStart) return "partial";

      return null;
    };

    const filterRecursive = (items) => {
      const result = items
        .map((item) => {
          const filteredChildren = item.children
            ? filterRecursive(item.children)
            : [];
          const isTabularHyphenSearch = nondraggablecode;

          const matchType = isTabularHyphenSearch
            ? item.name
              ? matchText(item.name)
              : null
            : (item.name && matchText(item.name)) ||
              (item.description && matchText(item.description));
          const matchesParent = !!matchType;
          let childrenToInclude = [];

          if (activeTab === "ICD 10 AM Index" && !/\d/.test(lowerCaseQuery)) {
            childrenToInclude = matchesParent
              ? item.children || []
              : onChangeCodeBook
                ? []
                : filteredChildren;
          } else {
            childrenToInclude = matchesParent
              ? item.children || []
              : filteredChildren;
          }

          return {
            ...item,
            children: childrenToInclude,
            matches: matchesParent || childrenToInclude.length > 0,
            matchType, // 👈 important
          };
        })
        .filter((item) => item.matches || item.children?.length > 0);
      const hasExact = result.some((item) => item.matchType === "exact");
      if (hasExact) {
        return result.filter((item) => item.matchType === "exact");
      }
      return result;
    };

    return filterRecursive(items);
  };

  // const filteredDataMemo = useMemo(() => {
  //   const currentTabData = tabsConfig.find(
  //     (tab) => tab.name === activeTab
  //   )?.data;
  //   return filterData(currentTabData || [], searchQuery);
  // }, [activeTab, searchQuery, tabsConfig]);
  const filteredDataMemo = useMemo(() => {
    const currentTabData = tabsConfig.find(
      (tab) => tab.name === activeTab,
    )?.data;

    return filterData(currentTabData || [], searchQuery, searchByCodeId);
  }, [activeTab, searchQuery, searchByCodeId, tabsConfig]);

  const handleSearchChange = (e) => {
    // console.log('seeins', e.target.value);
    if (e.target.value) {
      dispatch(setOnChangeCodeBook(true));
    } else {
      dispatch(setOnChangeCodeBook(false));
    }

    const newValue = e.target.value;
    if (newValue !== rawSearchQuery) {
      dispatch(setRawSearchQuery(newValue));
      dispatch(setNondraggablecode(false));
      // dispatch(setSearchByCodeId(null))
      if (searchByCodeId) dispatch(setSearchByCodeId(null));
    }
    // console.log('onChangeCodeBook');
  };

  const handleIconClick = (icon) => {
    // dispatch(setOnChangeCodeBook(false));
    dispatch(setActiveIcon(icon));
    dispatch(setSearchByCodeId(null));
    dispatch(setRawSearchQuery(""));
    dispatch(clearHyperlinkNavigationHistory());
    if (icon === "ICD") dispatch(setActiveTab("ICD 10 AM Index"));
    else if (icon === "Tabular") dispatch(setActiveTab("ICD 10 AM Tabular"));
    else if (icon === "Coding") {
      dispatch(updateAcsCode(""));
      dispatch(setActiveTab("Australian Coding Standard"));
      dispatch(updateNcaCode(""));
    } else if (icon === "References")
      dispatch(setActiveTab("Additional References"));
      dispatch(updateAcsCode(""));
      dispatch(updateNcaCode(""));


    // if (icon !== "Coding") {
    //   navigate('/coder')
    // };
  };

  const handleCodeNavigate = useCallback(
    (cleanedCode, sourceItemId) => {
      const targetTab = isAchiCode(cleanedCode)
        ? "ACHI Tabular"
        : "ICD 10 AM Tabular"; //route based on the code itself

      const currentData =
        tabsConfig.find((t) => t.name === activeTab)?.data || [];
      const idx = currentData.findIndex((it) => it.id === sourceItemId);

      dispatch(
        pushNavigationEntry({
          activeTab,
          activeIcon,
          rawSearchQuery,
          searchQuery,
          searchByCodeId,
          nondraggablecode,
          selectedCodebookVersion,
          sourceItemId,
          loadMore: idx >= 0 ? Math.max(loadMore, idx + 20) : loadMore,
        }),
      );

      debouncedQueryControl.cancel();
      setSearchQuery(cleanedCode);
      scrolledForTargetRef.current = null;
      skipTabClearRef.current = true;
      dispatch(setSearchByCodeId(null));
      dispatch(setNondraggablecode(true));
      dispatch(setActiveIcon("Tabular"));
      dispatch(setActiveTab(targetTab)); // dynamic tabName instead of the hardcoded string
      dispatch(setRawSearchQuery(cleanedCode));
    },
    [
      activeTab,
      activeIcon,
      rawSearchQuery,
      searchQuery,
      searchByCodeId,
      nondraggablecode,
      selectedCodebookVersion,
      loadMore,
      tabsConfig,
      debouncedQueryControl,
      dispatch,
    ],
  );
  const isAchiCode = (code) => /^[0-9]/.test(code);
const findItemById = (items, id) => {
  for (const item of items) {
    if (item.id === id) return item;
    if (item.children) {
      const found = findItemById(item.children, id);
      if (found) return found;
    }
  }
  return null;
};
const handleFieldCodeNavigate = useCallback(
  (codeOrId, sourceItemId, segType, explicitTargetTab = null) => {
    const targetIcon = "Tabular";
    
    // Determine the target tab
    let targetTab = explicitTargetTab;
    if (!targetTab) {
      // Determine based on the code type if no explicit tab provided
      if (typeof codeOrId === 'string' && !/^\d+$/.test(codeOrId)) {
        targetTab = isAchiCode(codeOrId) ? "ACHI Tabular" : "ICD 10 AM Tabular";
      } else {
        // Default based on current active tab
        targetTab = activeTab === "ACHI Tabular" ? "ACHI Tabular" : "ICD 10 AM Tabular";
      }
    }

    const currentData =
      tabsConfig.find((t) => t.name === activeTab)?.data || [];
    const idx = currentData.findIndex((it) => it.id === sourceItemId);

    dispatch(
      pushNavigationEntry({
        activeTab,
        activeIcon,
        rawSearchQuery,
        searchQuery,
        searchByCodeId,
        nondraggablecode,
        selectedCodebookVersion,
        sourceItemId,
        loadMore: idx >= 0 ? Math.max(loadMore, idx + 20) : loadMore,
      })
    );

    debouncedQueryControl.cancel();
    scrolledForTargetRef.current = null;
    skipTabClearRef.current = true;

    // Special handling for parent navigation
    if (segType === 'parent') {
      // For parent navigation, set searchByCodeId to the parent ID
      // This will filter to show only the parent and its hierarchy
      dispatch(setSearchByCodeId(codeOrId));
      dispatch(setNondraggablecode(true));
      
      // Set the search query to the parent name for display
      const parentData = tabsConfig.find((t) => t.name === targetTab)?.data || [];
      const parentItem = findItemById(parentData, codeOrId);
      if (parentItem) {
        dispatch(setRawSearchQuery(parentItem.name));
      } else {
        dispatch(setRawSearchQuery(codeOrId.toString()));
      }
    } else {
      dispatch(setSearchByCodeId(null));
      dispatch(setNondraggablecode(true));
      // For regular code navigation, clean and set the code
      let cleanedCode = codeOrId;
      if (typeof codeOrId === 'string') {
        cleanedCode = codeOrId.trim().replace(/-\†|\-\+|\-\*$/g, '');
        if (cleanedCode.endsWith('-')) cleanedCode = cleanedCode.slice(0, -1);
      }
      dispatch(setRawSearchQuery(cleanedCode));
    }

    dispatch(setActiveIcon(targetIcon));
    dispatch(setActiveTab(targetTab));
  },
  [
    activeTab,
    activeIcon,
    rawSearchQuery,
    searchQuery,
    searchByCodeId,
    nondraggablecode,
    selectedCodebookVersion,
    loadMore,
    tabsConfig,
    debouncedQueryControl,
    dispatch,
  ]
);
  const handleAcsNavigate = useCallback(
    (acsCode) => {
      dispatch(
        pushNavigationEntry({
          activeTab,
          activeIcon,
          rawSearchQuery,
          searchQuery,
          searchByCodeId,
          nondraggablecode,
          selectedCodebookVersion,
          sourceItemId: null, // no list to scroll back to on this tab
          loadMore,
        }),
      );

      dispatch(updateAcsCode(acsCode));
      dispatch(setActiveTab("Australian Coding Standard"));
      dispatch(setActiveIcon("Coding"));
    },
    [
      activeTab,
      activeIcon,
      rawSearchQuery,
      searchQuery,
      searchByCodeId,
      nondraggablecode,
      selectedCodebookVersion,
      loadMore,
      dispatch,
    ],
  );

  const handleNcaNavigate = useCallback(
    (ncaCode) => {
      dispatch(
        pushNavigationEntry({
          activeTab,
          activeIcon,
          rawSearchQuery,
          searchQuery,
          searchByCodeId,
          nondraggablecode,
          selectedCodebookVersion,
          sourceItemId: null,
          loadMore,
        }),
      );

      dispatch(updateNcaCode(null));
      setTimeout(() => dispatch(updateNcaCode(ncaCode)), 0);
      dispatch(setActiveIcon("References"));
      dispatch(setActiveTab("National Coding Advice"));
    },
    [
      activeTab,
      activeIcon,
      rawSearchQuery,
      searchQuery,
      searchByCodeId,
      nondraggablecode,
      selectedCodebookVersion,
      loadMore,
      dispatch,
    ],
  );
  const normalizeIndexTerm = (str = "") =>
    str
      .toLowerCase()
      .normalize("NFD")
      .replace(/[\u0300-\u036f]/g, "")
      .replace(/['’]/g, "")
      .replace(/[()]/g, " ")
      .replace(/-/g, " ")
      .replace(/[^a-z0-9\s]/g, " ")
      .replace(/\s+/g, " ")
      .trim();

  const findIndexNodeByHead = (items, headNorm) =>
    items.find((it) => normalizeIndexTerm(it.name) === headNorm) ||
    items.find((it) => normalizeIndexTerm(it.name).startsWith(headNorm));

  const findIndexItemByPath = (items, path) => {
    if (!items?.length || !path.length) return null;
    const [head, ...rest] = path;
    const match = findIndexNodeByHead(items, normalizeIndexTerm(head));
    if (!match) return null;
    if (rest.length === 0) return match;

    const childMatch = match.children?.length
      ? findIndexItemByPath(match.children, rest)
      : null;

    // If the deeper segment ("congenital") isn't found, fall back to the
    // parent we did resolve ("Malposition") rather than failing entirely.
    return childMatch || match;
  };
  const findAchiCodeByBlock = (items, codePrefix, blockNumber) => {
    const blockToken = `[${blockNumber}]`;
    let fallback = null;

    const walk = (nodes) => {
      for (const node of nodes) {
        const name = node.name || "";
        const description = node.description || "";
        const combined = `${name} ${description}`;

        if (combined.includes(blockToken)) {
          if (name.replace(/[^\d]/g, "").startsWith(codePrefix)) {
            return node; // best match: same block AND same code prefix
          }
          if (!fallback) fallback = node; // first item in the right block, as a fallback
        }

        if (node.children?.length) {
          const found = walk(node.children);
          if (found) return found;
        }
      }
      return null;
    };

    return walk(items) || fallback;
  };
  const handleAchiBlockNavigate = useCallback(
    (codePrefix, blockNumber, sourceItemId) => {
      const tabularData =
        tabsConfig.find((t) => t.name === "ACHI Tabular")?.data || [];
      const target = findAchiCodeByBlock(tabularData, codePrefix, blockNumber);

      if (!target) {
        toast.error(`Code ${codePrefix} in block ${blockNumber} not found`);
        return;
      }

      const currentData =
        tabsConfig.find((t) => t.name === activeTab)?.data || [];
      const idx = currentData.findIndex((it) => it.id === sourceItemId);

      dispatch(
        pushNavigationEntry({
          activeTab,
          activeIcon,
          rawSearchQuery,
          searchQuery,
          searchByCodeId,
          nondraggablecode,
          selectedCodebookVersion,
          onChangeCodeBook,
          sourceItemId,
          loadMore: idx >= 0 ? Math.max(loadMore, idx + 20) : loadMore,
        }),
      );

      debouncedQueryControl.cancel();
      scrolledForTargetRef.current = null;
      skipTabClearRef.current = true;
      setSearchQuery(target.name);

      dispatch(setOnChangeCodeBook(true));
      dispatch(setNondraggablecode(true));
      dispatch(setSearchByCodeId(target.id)); // direct id-based jump, bypasses text search entirely
      dispatch(setActiveIcon("Tabular"));
      dispatch(setActiveTab("ACHI Tabular"));
      dispatch(setRawSearchQuery(target.name));
    },
    [
      activeTab,
      activeIcon,
      rawSearchQuery,
      searchQuery,
      searchByCodeId,
      nondraggablecode,
      selectedCodebookVersion,
      onChangeCodeBook,
      loadMore,
      tabsConfig,
      debouncedQueryControl,
      dispatch,
    ],
  );

  const handleSeeNavigate = useCallback(
    (term, sourceItemId) => {
      // Index -> Index only, and only within the same Index tab
      if (activeTab !== "ICD 10 AM Index" && activeTab !== "ACHI Index") return;

      const path = term
        .split("/")
        .map((s) => s.trim())
        .filter(Boolean);
      if (!path.length) return;

      const currentData =
        tabsConfig.find((t) => t.name === activeTab)?.data || [];
      const target = findIndexItemByPath(currentData, path);

      if (!target) {
        toast.error(`"${term}" not found in the index`);
        return;
      }

      const idx = currentData.findIndex((it) => it.id === sourceItemId);

      dispatch(
        pushNavigationEntry({
          activeTab,
          activeIcon,
          rawSearchQuery,
          searchQuery,
          searchByCodeId,
          nondraggablecode,
          selectedCodebookVersion,
          sourceItemId,
          loadMore: idx >= 0 ? Math.max(loadMore, idx + 20) : loadMore,
        }),
      );

      debouncedQueryControl.cancel();
      scrolledForTargetRef.current = null;
      skipCenterScrollRef.current = true;
      setSearchQuery(target.name);
      dispatch(setNondraggablecode(false));
      dispatch(setSearchByCodeId(target.id));
      dispatch(setRawSearchQuery(target.name));
      // activeTab / activeIcon deliberately untouched — stays Index -> Index
    },
    [
      activeTab,
      activeIcon,
      rawSearchQuery,
      searchQuery,
      searchByCodeId,
      nondraggablecode,
      selectedCodebookVersion,
      loadMore,
      tabsConfig,
      debouncedQueryControl,
      dispatch,
    ],
  );

  const handleBack = (e) => {
    e?.preventDefault();
    e?.stopPropagation();
    const last = navigationHistory[navigationHistory.length - 1];
    if (!last) return;

    const willRestoreScroll = !!(
      last.sourceItemId ||
      last.searchByCodeId ||
      (last.searchQuery && last.searchQuery.length >= 2)
    );

    restoringRef.current = willRestoreScroll;
    pendingAnchorRef.current = last.sourceItemId || null;
    skipTabClearRef.current = true;
    debouncedQueryControl.cancel();
    if (last.loadMore) setLoadMore(last.loadMore);
    setSearchQuery(last.searchQuery ?? "");
    dispatch(popNavigationEntry());
  };

  const getIcon = (icon) => {
    if (icon === "ICD") {
      return activeTab === "ICD 10 AM Index"
        ? booksIcon
        : activeTab === "ACHI Index"
          ? achiIcon
          : bookInactiveIcon; // Inactive icon for ICD
    }

    if (icon === "Tabular") {
      return activeTab === "ICD 10 AM Tabular"
        ? tabularicdIcon
        : activeTab === "ACHI Tabular"
          ? icd10amIcon
          : bookInactiveIcon; // Inactive icon for Tabular
    }

    if (icon === "Coding") {
      return activeTab === "Australian Coding Standard"
        ? australianIcon
        : bookIcon;
    }
    if (icon === "References") {
      return activeTab === "Additional References" ? earthIcon : earthIcon;
    }

    return bookInactiveIcon;
  };

  const getTooltipTitle = (icon) => {
    const edition =
      selectedCodebookVersion === "12th"
        ? "Twelfth Edition"
        : "Thirteenth Edition";
    switch (icon) {
      case "ICD":
        return activeTab === "ACHI Index"
          ? `ACHI Alphabetic Index ${edition}`
          : `ICD-10-AM Alphabetic Index ${edition}`;

      case "Tabular":
        return activeTab === "ACHI Tabular"
          ? `ACHI Tabular List ${edition}`
          : `ICD-10-AM Tabular List ${edition}`;

      case "Coding":
        return `Australian Coding Standards ${edition}`;

      default:
        return "";
    }
  };

  const handleDrop = (code) => {
    setDroppedCodes((prev) => [...prev, code]);
  };
  const findDeepestMatchId = (items) => {
    for (const item of items) {
      if (item.children?.length) {
        const childId = findDeepestMatchId(item.children);
        if (childId) return childId;
      }
      if (item.matchType) return item.id; // own match checked LAST
    }
    return null;
  };
  const findBestMatchId = (items) => {
    // 1. Prefer an EXACT match at this level, without descending further.
    for (const item of items) {
      if (item.matchType === "exact") return item.id;
    }
    // 2. Otherwise, look for an exact match inside children.
    for (const item of items) {
      if (item.children?.length) {
        const childId = findBestMatchId(item.children);
        if (childId) return childId;
      }
    }
    // 3. Fall back to any partial match at this level.
    for (const item of items) {
      if (item.matchType) return item.id;
    }
    // 4. Last resort — old deepest-match behavior, for edge cases with no exact match anywhere.
    for (const item of items) {
      if (item.children?.length) {
        const childId = findDeepestMatchId(item.children);
        if (childId) return childId;
      }
      if (item.matchType) return item.id;
    }
    return null;
  };

  const getScrollTargetId = useCallback(() => {
    if (pendingAnchorRef.current) return pendingAnchorRef.current;
    if (searchByCodeId) return searchByCodeId;
    if (
      searchQuery &&
      searchQuery.length >= 2 &&
      filteredDataMemo?.length > 0
    ) {
      return (
        findBestMatchId(filteredDataMemo) ?? filteredDataMemo[0]?.id ?? null
      ); // 👈 swap
    }
    return null;
  }, [searchByCodeId, searchQuery, filteredDataMemo]);

  useEffect(() => {
    if (restoringRef.current) return;
    setLoadMore(50);
  }, [activeTab, searchQuery, selectedCodebookVersion]);
  useEffect(() => {
    if (restoringRef.current) return;
    if (searchResultsRef.current) {
      searchResultsRef.current.scrollTop = 0;
    }
  }, [activeTab, selectedCodebookVersion, searchQuery, searchByCodeId]);
  useEffect(() => {
    setDisplayedItems(filteredDataMemo?.slice(0, loadMore));
  }, [filteredDataMemo, loadMore]);
  const handleScroll = useCallback(() => {
    if (!searchResultsRef.current) return;

    const { scrollTop, scrollHeight, clientHeight } = searchResultsRef.current;

    // If scrolled to the bottom, load 10 more items
    if (scrollTop + clientHeight >= scrollHeight - 50) {
      setLoadMore((prev) => prev + 10);
    }
  }, []);

  useEffect(() => {
    const element = searchResultsRef.current;
    if (element) {
      element.addEventListener("scroll", handleScroll);
    }
    return () => {
      if (element) {
        element.removeEventListener("scroll", handleScroll);
      }
    };
  }, [handleScroll, activeIcon, activeTab]);
  // useEffect(()=>{
  //   console.log(onChangeCodeBook,'onChangeCodeBook');

  // },[onChangeCodeBook])

  // EFFECT 2 — Scroll only when allowed
  // useEffect(() => {
  //   if (!shouldScrollRef.current) return;
  //   if (!searchQuery && !searchByCodeId) return;

  //   let scrollDone = false;
  //   const timerIds = [];

  //   const tryScroll = (delay) => {
  //     const id = setTimeout(() => {
  //       if (scrollDone) return;
  //       if (!shouldScrollRef.current) return;
  //       if (!firstMatchRef.current || !searchResultsRef.current) return;

  //       const containerTop =
  //         searchResultsRef.current.getBoundingClientRect().top;
  //       const elementTop = firstMatchRef.current.getBoundingClientRect().top;
  //       const scrollOffset = elementTop - containerTop;

  //       if (Math.abs(scrollOffset) > 5) {
  //         searchResultsRef.current.scrollTop =
  //           searchResultsRef.current.scrollTop + scrollOffset - 20;
  //       }
  //       scrollDone = true;
  //     }, delay);
  //     timerIds.push(id);
  //   };

  //   const onManualScroll = () => {
  //     scrollDone = true;
  //     shouldScrollRef.current = false;
  //   };
  //   searchResultsRef.current?.addEventListener("scroll", onManualScroll, {
  //     once: true,
  //   });

  //   tryScroll(500);
  //   tryScroll(800);
  //   tryScroll(1100);
  //   return () => {
  //     timerIds.forEach(clearTimeout);
  //     searchResultsRef.current?.removeEventListener("scroll", onManualScroll);
  //   };
  // }, [displayedItems]);
  //Both hyperlink and audot scroll replaced with one useEffect that handles both cases
  useEffect(() => {
    if (skipCenterScrollRef.current) {
      skipCenterScrollRef.current = false;
      const targetId = getScrollTargetId();
      if (targetId) {
        scrolledForTargetRef.current = targetId;
      }
      restoringRef.current = false;
      return;
    }
    const targetId = getScrollTargetId();
    if (!targetId) {
      restoringRef.current = false;
      return;
    }
    if (scrolledForTargetRef.current === targetId) {
      return;
    }

    let attempts = 0;
    let cancelled = false;

    const onManualScroll = () => {
      cancelled = true;
    };
    searchResultsRef.current?.addEventListener("scroll", onManualScroll, {
      once: true,
    });

    const tryScroll = () => {
      if (cancelled) return;
      const container = searchResultsRef.current;
      const el = container?.querySelector(`[data-item-id="${targetId}"]`);

      if (el && container) {
        const containerRect = container.getBoundingClientRect();
        const elRect = el.getBoundingClientRect();
        const relativeOffset = elRect.top - containerRect.top;
        const centeredOffset =
          relativeOffset - container.clientHeight / 2 + el.clientHeight / 2;

        if (Math.abs(centeredOffset) > 5) {
          container.scrollTop = container.scrollTop + centeredOffset;
        }

        scrolledForTargetRef.current = targetId;

        if (pendingAnchorRef.current === targetId) {
          pendingAnchorRef.current = null;
          restoringRef.current = false;
        }
      } else if (attempts < 15) {
        attempts++;
        setTimeout(tryScroll, 150);
      } else if (pendingAnchorRef.current === targetId) {
        pendingAnchorRef.current = null;
        restoringRef.current = false;
      }
    };

    tryScroll();

    return () => {
      searchResultsRef.current?.removeEventListener("scroll", onManualScroll);
    };
  }, [displayedItems, getScrollTargetId]);
  useEffect(() => {
  const handleKeyDown = (event) => {
    // Trigger only for Alt + R, not Ctrl/Cmd + Alt + R
    if (
      event.altKey &&
      !event.ctrlKey &&
      !event.metaKey &&
      event.key.toLowerCase() === "r"
    ) {
      event.preventDefault();
      event.stopPropagation();

      setShowReferencesDropdown((prev) => {
        const newState = !prev;

        if (newState) {
          dispatch(setActiveIcon("References"));
        }

        return newState;
      });
    }
  };

  window.addEventListener("keydown", handleKeyDown);

  return () => {
    window.removeEventListener("keydown", handleKeyDown);
  };
}, [dispatch]);
  return (
    <div className="codebook-container">
      <CodeBookHeader
        activeIcon={activeIcon}
        codeBookLoading={codeBookLoading}
        getIcon={getIcon}
        getTooltipTitle={getTooltipTitle}
        onIconClick={handleIconClick}
        showReferencesDropdown={showReferencesDropdown}
        onToggleReferences={() => setShowReferencesDropdown((previous) => !previous)}
        onReferenceSelect={(reference) => {
          setSelectedReference(reference);
          dispatch(setActiveIcon("References"));
          dispatch(setActiveTab(reference === "nationalCoding" ? "National Coding Advice" : reference));
          dispatch(setRawSearchQuery(""));
          setShowReferencesDropdown(false);
        }}
        hasNavigationHistory={navigationHistory.length > 0}
        onBack={handleBack}
        selectedCodebookVersion={selectedCodebookVersion}
        onVersionChange={handleChange}
      />
      <CodeBookTabs
        activeIcon={activeIcon}
        activeTab={activeTab}
        onTabChange={(tab) => dispatch(setActiveTab(tab))}
      />

      {/* <div className="search-bar-code">
        <FaSearch className="search-icon" />
        <input
          type="text"
          className="search-input"
          placeholder="Search by code or description"
          value={rawSearchQuery}
          onChange={handleSearchChange}
        />
 
      </div> */}
      <CodeBookSearchField
        value={rawSearchQuery}
        onChange={handleSearchChange}
      />
            {/* ====================== SEARCH BAR WITH CONDITION ====================== */}
      {activeTab === "Morphology" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/DxTabAppendixA.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="Morphology"
          /> */}
           <SearchableIframe
      src="/documents/DxTabAppendixA.html"
      title="Morphology"
      query={rawSearchQuery}

    />
        </div>
      )}
      {activeTab === "StateAdvice-NSW" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/NSW_State.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="StateAdvice"
          /> */}
           <SearchableIframe
      src="/documents/NSW_State.html"
      title="State Advice NSW"
            query={rawSearchQuery}

    />
        </div>
      )}
      {activeTab === "StateAdvice-VIC" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/VICC.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="StateAdvice"
          /> */}
           <SearchableIframe
      src="/documents/NSW_State.html"
      title="State Advice NSW"
            query={rawSearchQuery}

    />
        </div>
      )}
         {activeTab === "StateAdvice-QLD" && (
        <div className="pdf-container" style={{ height: "calc(100vh - 380px)" }}>
          {/* <iframe
            src="/documents/QLD.html"
            width="100%"
            style={{ height: "calc(100vh - 380px)" }}
            title="StateAdvice"
          /> */}
           <SearchableIframe
      src="/documents/VICC.html"
      title="State Advice VIC"
            query={rawSearchQuery}
    />
        </div>
      )}

      {activeTab === "National Coding Advice" && (
  <div className="pdf-container">
    <NCADocumentViewer query={rawSearchQuery}/>
  </div>
)}
      {activeTab === "Australian Coding Standard" ? (
          <div className="acs-wrapper">
       { selectedCodebookVersion === "12th" ? (
          <AustralianCodebook searchQuery={rawSearchQuery}/>
        ) : (
          <ACSCodeBook13th  query={rawSearchQuery}/>
        )}
        </div>
      ) : (
        ![
          "National Coding Advice",
          "Morphology",
          "StateAdvice-NSW",
          "StateAdvice-VIC",
          "StateAdvice-QLD",
        ].includes(activeTab) && (
          <div className="search-results" ref={searchResultsRef}>
            {/* {activeTab === "Australian Coding Standard" && <AustralianCodebook />} */}
            <div className="accordion-container">
              {/* {
            codeBookLoading ? <div className="codebook-loader">
              <Spinner />{" "}
            </div> : <>
              {displayedItems.map((item,index) => (<AccordionItem key={index} item={item} searchQuery={searchQuery} activeTab={activeTab} />))}
            </>
          } */}
              {(() => {
                // Check if data is actually available in IndexedDB
                const hasData =
                  selectedCodebookVersion === "13th"
                    ? icd10amIndexData13?.length > 0 ||
                      achiIndexData13?.length > 0
                    : icd10amIndexData?.length > 0 || achiIndexData?.length > 0;

                // Check sessionStorage
                const isFetched =
                  selectedCodebookVersion === "13th"
                    ? sessionStorage.getItem("isFetched13") === "true"
                    : sessionStorage.getItem("isFetched12") === "true";

                // Only show loader if NO data is available
                const showInternalLoader =
                  (codeBookLoading ||
                    (selectedCodebookVersion === "12th" && !isFetched12) ||
                    (selectedCodebookVersion === "13th" && !isFetched13)) &&
                  !hasData &&
                  !isFetched;

                if (showInternalLoader) {
                  return (
                    <div className="codebook-loader">
                      <LdsRoller />
                    </div>
                  );
                }

                // Show the actual content
                return (
                  <>
                    {displayedItems.length > 0
                      ? displayedItems.map((item, index) => (
                          <AccordionItem
                            key={index}
                            item={item}
                            searchByCodeId={searchByCodeId}
                            searchQuery={searchQuery}
                            activeTab={activeTab}
                            isTopLevel={item.children.length === 0}
                            setActiveTab={setActiveTab}
                            dispatch={dispatch}
                            setActiveIcon={setActiveIcon}
                            isLockedCoder={isLockedCoder}
                            onCodeNavigate={(code) => handleCodeNavigate(code, item.id)}
                            onFieldCodeNavigate={(codeOrId, segType, explicitTab) => 
                              handleFieldCodeNavigate(codeOrId, item.id, segType, explicitTab)
                            }
                            onAcsNavigate={handleAcsNavigate}
                            onNcaNavigate={handleNcaNavigate}
                            onSeeNavigate={handleSeeNavigate}
                            onAchiBlockNavigate={(codePrefix, blockNumber) =>
                              handleAchiBlockNavigate(codePrefix, blockNumber, item.id)
                            }
                            />
                          ))
                      : searchQuery.length >= 2 &&
                        activeTab !== "National Coding Advice" &&
                        activeTab !== "Morphology" &&
                        activeTab !== "StateAdvice-NSW" &&
                        activeTab !== "StateAdvice-VIC" &&
                        activeTab !== "StateAdvice-QLD" && (
                          <div>No matches found</div>
                        )}
                  </>
                );
              })()}
            </div>

            {/* <div className="staricon">
            <img src={starsIcon} alt="Star Icon" />
        </div> */}
          </div>
        )
      )}
    </div>
  );
});

export default React.memo(CodeBookDev);
